// extracted by mini-css-extract-plugin
export default {"container":"thankyou_container__IJKdh"};